import { graphql } from '~/graphql';
import type {
  ImportPlatformProductsMutation,
  ImportPlatformProductsMutationVariables,
} from '~/graphql/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { ADMIN_PLATFORM_PRODUCTS_QUERY_KEY } from '~/api/platformProductClassification';
import { PLATFORM_PRODUCT_QUERY_KEY } from '~/api/platformProducts';

const importPlatformProductsMutation = graphql(`
  mutation ImportPlatformProducts(
    $input: PlatformProductImportInput!
    $dryRun: Boolean!
  ) {
    importPlatformProducts(input: $input, dryRun: $dryRun) {
      fileErrors
      rowErrors {
        rowNumber
        code
        messages
      }
      products {
        code
        action
        createdFields {
          field
          value
        }
        addedLengths
        addedCapacities
        conflicts {
          field
          currentValue
          importedValue
        }
      }
    }
  }
`);

export const appliedWithoutErrors = (
  data: ImportPlatformProductsMutation,
  variables: ImportPlatformProductsMutationVariables
): boolean =>
  !variables.dryRun &&
  data.importPlatformProducts.fileErrors.length === 0 &&
  data.importPlatformProducts.rowErrors.length === 0;

export function useImportPlatformProducts() {
  return useGraphqlMutation(
    importPlatformProductsMutation,
    [ADMIN_PLATFORM_PRODUCTS_QUERY_KEY, PLATFORM_PRODUCT_QUERY_KEY],
    undefined,
    { shouldInvalidate: appliedWithoutErrors }
  );
}
